import { forwardRef, useState } from 'react';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { formatTime } from '../../../../media.utils';
import { MediaFileProps } from '../../media-file.types';
import {
  InlineSpinner,
  Text,
  SVG,
} from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { VideoBadge } from './video.styled';
import { VideoEl } from '../../media-file.styled';

export const Video = forwardRef<
  HTMLVideoElement,
  Pick<MediaFileProps, 'file' | 'view' | 'mode'>
>(({ file, mode, view = 'cover' }, ref) => {
  const theme = useV4Theme();

  const [loading, setLoading] = useState<boolean>(true);
  const [duration, setDuration] = useState<string>('');

  const handleLoadedMetadata = (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const video = e.currentTarget;
    setLoading(false);
    setDuration(formatTime(video.duration));
  };

  return (
    <>
      <VideoEl
        ref={ref}
        src={file.src}
        preload="metadata"
        playsInline
        muted
        onLoadedMetadata={handleLoadedMetadata}
        style={{ objectFit: view }}
      />

      {loading && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: mode === 'preview' ? 'white' : 'currentcolor',
          }}
        >
          <InlineSpinner />
        </div>
      )}

      {!loading && mode !== 'preview' && (
        <VideoBadge
          $mode={mode}
          style={{
            top: mode === 'thumbnail' ? '50%' : theme.spacings.xs,
            right: mode === 'thumbnail' ? '50%' : theme.spacings.xs,
          }}
        >
          <SVG src={Icons.Play} />
          <Text truncate>{duration}</Text>
        </VideoBadge>
      )}
    </>
  );
});
